import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Customer, CustomerFactory, ICredentials} from "../../typescript-library";
import {RootState} from "../store";

export type CustomerSliceState = {
  customer: Customer;
  loading: boolean;
};

export const createCustomer = createAsyncThunk<Customer>("customer/create", async () => {
  return await CustomerFactory.getCustomer();
});

export const loginCustomer = createAsyncThunk<boolean, ICredentials, {state: RootState}>(
  "customer/login",
  async (credentials, {getState}) => {
    return await getState().customer.customer.logIn(credentials);
  },
);

const initialState: CustomerSliceState = {
  customer: null as unknown as Customer,
  loading: true,
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomerState: (state: CustomerSliceState, action: PayloadAction<Customer>) => {
      state.customer = action.payload;
    },
  },
  extraReducers: (builder) => {
    return builder
      .addCase(createCustomer.pending, (state) => {
        return {...state, loading: true};
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        return {...state, customer: action.payload, loading: false};
      });
  },
});

export const {setCustomerState} = customerSlice.actions;
